// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminal-prompt {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-bottom: 1.25rem;
}

.terminal-prompt .user { color: var(--accent); }
.terminal-prompt .path { color: var(--cyan); }

.typing-cursor {
  color: var(--accent);
  animation: blink 1s step-end infinite;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 3rem;
  align-items: center;
  padding: 3rem 0 4rem;
}

.hero-content h1 {
  font-size: clamp(1.75rem, 5vw, 2.75rem);
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 0.75rem;
}

.tagline {
  font-family: var(--font-mono);
  font-size: 0.82rem;
  color: var(--orange);
  margin-bottom: 1rem;
  font-style: italic;
}

.bio {
  color: var(--text-muted);
  max-width: 520px;
  margin-bottom: 1.75rem;
  font-size: 0.95rem;
}

.hero-actions { display: flex; flex-wrap: wrap; gap: 0.75rem; }

.avatar-wrap {
  position: relative;
  text-align: center;
}

.avatar-wrap img {
  width: 220px;
  height: 220px;
  border-radius: var(--radius);
  border: 2px solid var(--border);
  object-fit: cover;
  filter: grayscale(20%);
  transition: filter var(--transition), border-color var(--transition);
}

.avatar-wrap:hover img {
  filter: grayscale(0%);
  border-color: var(--accent);
  box-shadow: 0 0 32px var(--accent-glow);
}

.avatar-meta {
  margin-top: 1rem;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--text-muted);
  text-align: left;
  line-height: 1.8;
}

.avatar-meta strong { color: var(--accent); display: block; margin-bottom: 0.25rem; }

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
}

.stat-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.5rem;
  text-align: center;
  transition: border-color var(--transition), transform var(--transition);
}

.stat-card:hover {
  border-color: var(--accent);
  transform: translateY(-2px);
}

.stat-card .num {
  font-family: var(--font-mono);
  font-size: 2rem;
  font-weight: 700;
  color: var(--accent);
}

.stat-card .label {
  font-size: 0.78rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}

.project-card {
  display: block;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1.25rem 1.5rem;
  text-decoration: none;
  color: inherit;
  transition: border-color var(--transition), box-shadow var(--transition);
}

.project-card:hover {
  border-color: var(--accent);
  box-shadow: 0 4px 24px var(--accent-glow);
}

.project-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.project-name {
  font-family: var(--font-mono);
  font-weight: 600;
  color: var(--cyan);
  font-size: 0.95rem;
}

.project-stars {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  color: var(--orange);
}

.project-desc {
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.5;
  margin-bottom: 1rem;
}

.project-meta {
  display: flex;
  justify-content: space-between;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--text-muted);
}

.project-meta .lang {
  padding: 0.15rem 0.5rem;
  background: var(--bg-elevated);
  border-radius: 3px;
  color: var(--accent);
}

.posts-list { display: flex; flex-direction: column; gap: 0; }

.post-item {
  display: grid;
  grid-template-columns: 5.5rem 1fr auto;
  gap: 1rem;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid var(--border);
  text-decoration: none;
  color: inherit;
  transition: background var(--transition);
}

.post-item:first-child { border-top: 1px solid var(--border); }

.post-item:hover {
  background: var(--bg-card);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  margin: 0 -0.75rem;
  border-radius: var(--radius);
}

.post-date {
  font-family: var(--font-mono);
  font-size: 0.75rem;
  color: var(--text-muted);
}

.post-title {
  font-size: 0.95rem;
  color: var(--text);
  transition: color var(--transition);
}

.post-item:hover .post-title { color: var(--accent); }

.post-cat {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--cyan);
  opacity: 0.8;
}

.about-block {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 2rem;
  font-family: var(--font-mono);
  font-size: 0.85rem;
  line-height: 2;
  color: var(--text-muted);
}

.about-block dt { color: var(--accent); display: inline; }
.about-block dd { display: inline; margin: 0; color: var(--text); }
.about-block dd::after { content: '\\A'; white-space: pre; }

.page-intro {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-bottom: 2rem;
  max-width: 600px;
}

.archive-note {
  margin-top: 1.5rem;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--text-muted);
}

@media (max-width: 768px) {
  .hero-grid { grid-template-columns: 1fr; }
  .avatar-wrap { order: -1; }
  .avatar-wrap img { width: 160px; height: 160px; }
  .post-item {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/ui.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,yBAAyB,oBAAoB,EAAE;AAC/C,yBAAyB,kBAAkB,EAAE;;AAE7C;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gBAAgB,aAAa,EAAE,eAAe,EAAE,YAAY,EAAE;;AAE9D;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB,oBAAoB,EAAE,cAAc,EAAE,sBAAsB,EAAE;;AAEpF;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,cAAc,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;;AAE7D;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,yBAAyB,mCAAmC,EAAE;;AAE9D;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,+BAA+B,oBAAoB,EAAE;;AAErD;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,kBAAkB,oBAAoB,EAAE,eAAe,EAAE;AACzD,kBAAkB,eAAe,EAAE,SAAS,EAAE,kBAAkB,EAAE;AAClE,yBAAyB,aAAa,EAAE,gBAAgB,EAAE;;AAE1D;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa,0BAA0B,EAAE;EACzC,eAAe,SAAS,EAAE;EAC1B,mBAAmB,YAAY,EAAE,aAAa,EAAE;EAChD;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF","sourcesContent":[".terminal-prompt {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.85rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.terminal-prompt .user { color: var(--accent); }\r\n.terminal-prompt .path { color: var(--cyan); }\r\n\r\n.typing-cursor {\r\n  color: var(--accent);\r\n  animation: blink 1s step-end infinite;\r\n}\r\n\r\n.hero-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  gap: 3rem;\r\n  align-items: center;\r\n  padding: 3rem 0 4rem;\r\n}\r\n\r\n.hero-content h1 {\r\n  font-size: clamp(1.75rem, 5vw, 2.75rem);\r\n  font-weight: 700;\r\n  line-height: 1.25;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.tagline {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.82rem;\r\n  color: var(--orange);\r\n  margin-bottom: 1rem;\r\n  font-style: italic;\r\n}\r\n\r\n.bio {\r\n  color: var(--text-muted);\r\n  max-width: 520px;\r\n  margin-bottom: 1.75rem;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.hero-actions { display: flex; flex-wrap: wrap; gap: 0.75rem; }\r\n\r\n.avatar-wrap {\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n.avatar-wrap img {\r\n  width: 220px;\r\n  height: 220px;\r\n  border-radius: var(--radius);\r\n  border: 2px solid var(--border);\r\n  object-fit: cover;\r\n  filter: grayscale(20%);\r\n  transition: filter var(--transition), border-color var(--transition);\r\n}\r\n\r\n.avatar-wrap:hover img {\r\n  filter: grayscale(0%);\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 32px var(--accent-glow);\r\n}\r\n\r\n.avatar-meta {\r\n  margin-top: 1rem;\r\n  font-family: var(--font-mono);\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  text-align: left;\r\n  line-height: 1.8;\r\n}\r\n\r\n.avatar-meta strong { color: var(--accent); display: block; margin-bottom: 0.25rem; }\r\n\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.stat-card {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius);\r\n  padding: 1.5rem;\r\n  text-align: center;\r\n  transition: border-color var(--transition), transform var(--transition);\r\n}\r\n\r\n.stat-card:hover {\r\n  border-color: var(--accent);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.stat-card .num {\r\n  font-family: var(--font-mono);\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--accent);\r\n}\r\n\r\n.stat-card .label {\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.projects-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.project-card {\r\n  display: block;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius);\r\n  padding: 1.25rem 1.5rem;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  transition: border-color var(--transition), box-shadow var(--transition);\r\n}\r\n\r\n.project-card:hover {\r\n  border-color: var(--accent);\r\n  box-shadow: 0 4px 24px var(--accent-glow);\r\n}\r\n\r\n.project-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.project-name {\r\n  font-family: var(--font-mono);\r\n  font-weight: 600;\r\n  color: var(--cyan);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.project-stars {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.75rem;\r\n  color: var(--orange);\r\n}\r\n\r\n.project-desc {\r\n  font-size: 0.88rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.5;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.project-meta {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-family: var(--font-mono);\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.project-meta .lang {\r\n  padding: 0.15rem 0.5rem;\r\n  background: var(--bg-elevated);\r\n  border-radius: 3px;\r\n  color: var(--accent);\r\n}\r\n\r\n.posts-list { display: flex; flex-direction: column; gap: 0; }\r\n\r\n.post-item {\r\n  display: grid;\r\n  grid-template-columns: 5.5rem 1fr auto;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  padding: 1rem 0;\r\n  border-bottom: 1px solid var(--border);\r\n  text-decoration: none;\r\n  color: inherit;\r\n  transition: background var(--transition);\r\n}\r\n\r\n.post-item:first-child { border-top: 1px solid var(--border); }\r\n\r\n.post-item:hover {\r\n  background: var(--bg-card);\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  margin: 0 -0.75rem;\r\n  border-radius: var(--radius);\r\n}\r\n\r\n.post-date {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.75rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.post-title {\r\n  font-size: 0.95rem;\r\n  color: var(--text);\r\n  transition: color var(--transition);\r\n}\r\n\r\n.post-item:hover .post-title { color: var(--accent); }\r\n\r\n.post-cat {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.7rem;\r\n  color: var(--cyan);\r\n  opacity: 0.8;\r\n}\r\n\r\n.about-block {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius);\r\n  padding: 2rem;\r\n  font-family: var(--font-mono);\r\n  font-size: 0.85rem;\r\n  line-height: 2;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.about-block dt { color: var(--accent); display: inline; }\r\n.about-block dd { display: inline; margin: 0; color: var(--text); }\r\n.about-block dd::after { content: '\\A'; white-space: pre; }\r\n\r\n.page-intro {\r\n  font-family: var(--font-mono);\r\n  font-size: 0.85rem;\r\n  color: var(--text-muted);\r\n  margin-bottom: 2rem;\r\n  max-width: 600px;\r\n}\r\n\r\n.archive-note {\r\n  margin-top: 1.5rem;\r\n  font-family: var(--font-mono);\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .hero-grid { grid-template-columns: 1fr; }\r\n  .avatar-wrap { order: -1; }\r\n  .avatar-wrap img { width: 160px; height: 160px; }\r\n  .post-item {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.35rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
